export const prodUrl = 'https://apim.carvana.io/web-eventable/api/graph';
export const devUrl = 'https://apim.zagforward.com/web-eventable/api/graph';
